import {getRequest} from 'util/apiHelper';

export const getWorthyRequest = async () => {
    return await getRequest('/api/admin/am-i-worthy');
};

export const getAnyRequest = async (url) => {
    return await getRequest(url);
};

export const getAdminUserDonations = async (userId) => {
    return await getRequest('/api/admin/user-donations/' + userId);
};

export const getAdminAllLinks = async () => {
    return await getRequest('/api/admin/all-links');
};